module.exports = __webpack_public_path__ + "7d883ba72b5dbc0229f5d1980205ee34.svg";